function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { clientConfigLabelApi } from '@/api/enterprise';
import { extractArrayIds, isInArray, removeDuplicateObjects, getArrayDifference } from '@/libs/public';
export default {
  name: '',
  props: {
    // 选中的标签数据
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    labelList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    ids: {
      // 客户管理—批量设置标签表格id集合
      type: Array,
      default: function _default() {
        return null;
      }
    },
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: '请选择标签'
    },
    isSearch: {
      type: Boolean,
      default: false
    },
    slotType: {
      type: String,
      default: ''
    },
    props: {
      type: Object,
      default: function _default() {
        return {
          children: 'children',
          label: 'name'
        };
      }
    }
  },
  data: function data() {
    return {
      valType: 'id',
      filterText: '',
      allIds: [],
      isSlots: false,
      showPopover: false,
      treeExpandData: [],
      labelIds: [],
      // 选中标签id
      selectList: [],
      // 选中标签数据
      treeData: []
    };
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    },
    value: function value(newVal, oldValue) {
      // this.labelIds = newVal.map(Number)
      // if (this.labelIds.length > 0) {
      //   this.selectList = this.findNamesByIds(this.treeData, this.labelIds)
      // }
    },
    labelList: function labelList(newVal, oldValue) {
      if (this.labelList.length > 0) {
        this.selectList = newVal;
        this.labelIds = extractArrayIds(this.selectList, this.valType);
      } else {
        this.selectList = [];
        this.labelIds = [];
      }
    },
    labelIds: function labelIds(val) {
      this.allIdsChange();
    }
  },
  created: function created() {
    document.addEventListener('click', this.handleGlobalClick);
  },
  mounted: function mounted() {
    if (this.$slots.custom) {
      this.isSlots = true;
    }
    if (this.list.length > 0) {
      this.valType = 'id';
      this.treeData = this.list;
    } else {
      this.valType = 'id';
    }
    if (this.labelList.length > 0) {
      this.selectList = this.labelList;
      this.labelIds = extractArrayIds(this.selectList, this.valType);
    }
    if (this.value.length > 0) {
      this.labelIds = this.value.map(Number);
    }
  },
  methods: {
    // 获取树形结构默认展开节点
    getRoleTreeRootNode: function getRoleTreeRootNode(res) {
      this.treeExpandData.push(res[0][this.valType]);
    },
    findNamesByIds: function findNamesByIds(tree, id) {
      var ids = id.map(function (str) {
        return parseInt(str);
      });
      var result = [];
      function traverse(node) {
        if (ids.includes(node.id)) {
          result.push(node);
        }
        if (node.children) {
          var _iterator = _createForOfIteratorHelper(node.children),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var child = _step.value;
              traverse(child);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }
      var _iterator2 = _createForOfIteratorHelper(tree),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var node = _step2.value;
          traverse(node);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return result;
    },
    cardTag: function cardTag(index, id) {
      this.selectList.splice(index, 1);
      this.labelIds = this.labelIds.filter(function (item) {
        return item != id;
      });
      this.confirmData();
    },
    allIdsChange: function allIdsChange() {
      var _this = this;
      this.treeData.map(function (item) {
        var arr = extractArrayIds(item[_this.props.children], _this.valType);
        if (_this.isContained(_this.labelIds, arr)) {
          _this.allIds.push(item[_this.valType]);
        } else {
          _this.allIds = _this.allIds.filter(function (item) {
            return item != item[_this.valType];
          });
        }
      });
    },
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    handleGlobalClick: function handleGlobalClick(e) {
      var treePopover = document.getElementById('treePopover');
      if (treePopover) {
        if (!treePopover.contains(e.target)) {
          this.showPopover = false;
        }
      }
    },
    handlePopoverShow: function handlePopoverShow() {
      if (this.ids && this.ids.length == 0) {
        this.$message.error('至少选一项');
        return false;
      }
      if (this.list.length == 0) {
        this.getTreeData();
      }
      this.showPopover = true;
    },
    handlePopoverHide: function handlePopoverHide() {
      this.showPopover = false;
    },
    // 判断一个数组里面是否完全包含另一个数组
    // 定义函数
    isContained: function isContained(a, b) {
      // a和b其中一个不是数组，直接返回false
      if (!(a instanceof Array) || !(b instanceof Array)) return false;
      var len = b.length;
      // a的长度小于b的长度，直接返回false

      if (a.length < len) return false;
      for (var i = 0; i < len; i++) {
        // 遍历b中的元素，遇到a没有包含某个元素的，直接返回false
        if (!a.includes(b[i])) return false;
      }
      // 遍历结束，返回true
      return true;
    },
    // 选择标签单选
    selectFn: function selectFn(node, data) {
      var _this2 = this;
      if (data.pid == 0) return false;
      if (isInArray(this.labelIds, data[this.valType])) {
        this.labelIds = this.labelIds.filter(function (item) {
          return item != data[_this2.valType];
        });
        this.selectList = this.selectList.filter(function (item) {
          return item[_this2.valType] != data[_this2.valType];
        });
        this.confirmData();
        return false;
      } else {
        this.selectList.push(data);
        this.labelIds = extractArrayIds(this.selectList, this.valType);
      }
      this.confirmData();
    },
    //  选择标签多选
    selectAllFn: function selectAllFn(node, data) {
      var _this3 = this;
      if (isInArray(this.allIds, data[this.valType])) {
        // 取消全选
        this.allIds = this.allIds.filter(function (item) {
          return item != data[_this3.valType];
        });
        this.selectList = getArrayDifference(this.selectList, data[this.props.children]);
        this.labelIds = extractArrayIds(this.selectList, this.valType);
        this.confirmData();
        return false;
      }

      // 全选
      this.allIds.push(data.id);
      if (data[this.props.children].length > 0) {
        this.labelIds = [];
        data[this.props.children].map(function (item) {
          _this3.selectList.push(item);
        });
        this.selectList = removeDuplicateObjects(this.selectList, this.valType);
        this.labelIds = extractArrayIds(this.selectList, this.valType);
      }
      this.confirmData();
    },
    confirmData: function confirmData() {
      var data = {
        ids: this.labelIds,
        list: this.selectList
      };
      this.$emit('handleLabelConf', data);
    },
    getTreeData: function getTreeData() {
      var _this4 = this;
      var data = {
        page: 0,
        limit: 0
      };
      clientConfigLabelApi(data).then(function (res) {
        _this4.treeData = res.data.list;
        _this4.getRoleTreeRootNode(res.data.list);
        if (_this4.value.length > 0) {
          _this4.selectList = _this4.findNamesByIds(_this4.treeData, _this4.labelIds);
        }
      });
    }
  }
};